import createLogger from '../helpers/log';

const logging = createLogger('videoContentHint');

const videoContentHints = ['', 'text', 'motion', 'detail'];

export const isValidVideoContentHint = hint => videoContentHints.includes(hint);

const getVideoTrackForStream = mediaStream => mediaStream?.getVideoTracks()?.[0];

/**
 * Sets contentHint for videoTrack of MediaStream
 * @param {MediaStream} mediaStream
 * @param {String} contentHint, one of "", "motion", "detail" or "text"
 */
// eslint-disable-next-line consistent-return
export const setVideoContentHint = (mediaStream, contentHint) => new Promise((resolve, reject) => {
  const error = (msg) => {
    logging.warn(msg);
    reject(new Error(msg));
  };
  if (!mediaStream?.getVideoTracks) {
    return error('Invalid media stream');
  }
  if (!isValidVideoContentHint(contentHint)) {
    return error('Invalid content hint. Valid content hints are "text", "detail", "motion", or ""');
  }
  const videoTrack = getVideoTrackForStream(mediaStream);
  if (!videoTrack) {
    return error('Tried to set contentHint but no video track is present');
  }
  if (videoTrack.contentHint === undefined) {
    return error('contentHint not supported by this browser');
  }
  videoTrack.contentHint = contentHint;
  resolve();
});

/**
 * Returns contentHint for videoTrack of MediaStream
 * @param {MediaStream} mediaStream
 * @returns {String} contentHint, one of "", "motion", "detail" or "text"

 */
export const getVideoContentHint = (mediaStream) => {
  const videoTrack = getVideoTrackForStream(mediaStream);
  return videoTrack?.contentHint || '';
};
